import { put, call, takeLatest } from 'redux-saga/effects'
import { GET_COUNTRIES_SUCCESS, GET_COUNTRIES } from './actions'
import { getCountriesAPI } from './apis'
import { Country } from '../../global/types'

export function* getCountries() {
  try {
    const countries: Country[] = yield call(getCountriesAPI)

    yield put({
      type: GET_COUNTRIES_SUCCESS,
      countries: countries.reduce(
        (accu, currentVal) => ({ ...accu, ...{ [currentVal.id]: currentVal } }),
        {},
      ),
    })
  } catch (error) {
    console.log(error)
  }
}
export function* rootSaga() {
  yield takeLatest(GET_COUNTRIES, getCountries)
}
